
import InputNumber from "primevue/inputnumber";
import FondoSPValidacion from "@/validation/PayrollTransmission/FondoSP";
import Tooltip from "@/components/layout/TooltipTransmission.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    InputNumber,
    Tooltip,
  },
  props: {
    nomina: String,
  },
  setup(props) {
    let [fondoSP, validaciones] =
      new FondoSPValidacion().ObtenerReglasValidacion();

    const v$ = useVuelidate(validaciones, fondoSP, {
      $scope: props.nomina,
    });

    return {
      fondoSP,
      v$,
    };
  },
};
